import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { EnumsValues } from './enums/EnumsValues';
import { useCustomQuery } from './hooks/apollo/ApolloCustomHooks';
import { IAppSetting } from './interfaces';
import { Query } from './services/graphql/query';

const SendActivity = () => {
  const location = useLocation();
  const { data, error } = useCustomQuery<{
    getAppSettingByKey: IAppSetting;
  }>(Query.getAppSettingByKey, {
    variables: {
      input: { key: EnumsValues.SettingNames.GAClientID },
    },
  });

  useEffect(() => {
    if (error)
      console.error('SendActivity: configuración de estadísticas', error);
  }, [error]);

  useEffect(() => {
    if (data?.getAppSettingByKey) {
      const src =
        'https://www.googletagmanager.com/gtag/js?id=' +
        data?.getAppSettingByKey.setting_value;

      const ga_script = document.createElement('script');
      ga_script.setAttribute('src', src);
      document.head.appendChild(ga_script);

      const scriptBody: string =
        'window.dataLayer = window.dataLayer || [];' +
        ' function gtag(){dataLayer.push(arguments);}' +
        " gtag('js', new Date()); gtag('config', '" +
        data?.getAppSettingByKey.setting_value +
        "');";

      const ga_data = document.createElement('script');
      ga_data.text = scriptBody;
      document.head.appendChild(ga_data);
    }
  }, [data, location]);
};

export default SendActivity;
